import $ from 'jquery';

import View from './view';

const Gallery = View.extend( {

    template: 'jst/gallery',
    
    initialize(options = { urls: [] }) {
        View.prototype.initialize.call( this, options );

        this.urls_ = options.urls;
    },

    open(index) {
        this.$( 'a' ).eq( index || 0 ).click();
    },

    serialize() {
        const guid = String( Math.random() );
        return {
            guid,
            urls: this.urls_.slice()
        };
    },

    afterRender(context, firstTime) {
        if (firstTime)
            this.$( 'a' ).fancybox( {
                buttons: ['fullScreen', 'close']
            } );
    },

}, {

    open(urls, index) {
        new Gallery( { urls } )
            .render()
            .then( view => {
                view.$el.appendTo( document.body );
                view.open( index );
             } );
    }

} );

export default Gallery;


// WEBPACK FOOTER //
// ./src/js/view/gallery.js